// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qk_a bhm_sw bhm_kx bhm_ky","PostDetailRight__brandDaysPosts":"qk_b bhm_sw bhm_kx bhm_ky"};